import { isDevelop } from "../utils";
export const baseDomaninName = isDevelop ? "http://localhost" : "/api";

export const basePort = isDevelop ? ":3334" : "";
export const publicURL = baseDomaninName + basePort;
// export const publicURL = "/api";

export const getVideoInformationURI = `${publicURL}/information`;
export const getDownloadLinkURI = `${publicURL}/download`;
export const getHlsLinkURI = `${publicURL}/hls`;
export const getAudioLinkURI = `${publicURL}/audio`;
